import { useEffect, useState } from "react";
import FlashTermAndCondModal from "../FooterSectComponents/FlashTermAndCondModal";
import "./StripOffer.scss"
import { useNavigate } from "react-router-dom";
import CONFIG from "../../utils/config";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
const StripOffer = (props) => {

    const { isTerm ,page} = props;
    const navigate = useNavigate();
    const authBroker = useSelector((state) => state.auth.authBroker);

    const [showModal, setShowModal] = useState(false);

    const [start, setStart] = useState(false);
    const [end, setEnd] = useState(false);

    useEffect(() => {
        const specificStartDate = moment.tz(CONFIG.OFFER_START_TIME, "America/New_York");
        const specificEndDate = moment.tz(CONFIG.OFFER_END_TIME, "America/New_York");
        const currentDate = moment.tz(new Date(), "America/New_York");
        setStart(currentDate.isAfter(specificStartDate));
        setEnd(currentDate.isBefore(specificEndDate))

    }, [])

    return (
        <>
            {authBroker?.payload?.user?.company_id === CONFIG.C21_COMPANY_ID && (start && end) ? <div className="container mb-3"><div className="mt-4">
                <div className="xsel-strip-box alert-warning d-flex justify-content-between gap-2 flex-wrap align-items-center">
                    <span>🎉 <strong>FLASH SALE! 10% OFF! (ALL PAID COURSES)</strong> DEC 11, 12:00 AM - DEC 12, 11:59 PM </span> {isTerm&&<strong className="cursor-pointer"
                        onClick={() => {
                            if (isTerm) {
                                setShowModal(true);
                                // window.open("/flash-term", '_blank', 'noopener,noreferrer');
                            } else {
                                if(page==="course"){
                                navigate("/learn/courses?tab=1&utm_source=Platform&utm_medium=Courses&utm_campaign=FlashSale2024")
                                }else if(page === "video"){
                                    navigate("/learn/courses?tab=1&utm_source=Platform&utm_medium=Videos&utm_campaign=FlashSale2024")
                                }else if(page==="partner"){
                                    navigate("/learn/courses?tab=1&utm_source=Platform&utm_medium=SideBannerPartners&utm_campaign=FlashSale2024")
                                }
                            }
                        }}><u>{isTerm ? "Terms & Conditions apply" : "Click here"}</u></strong>}
                </div>
            </div></div> : ""}

            <FlashTermAndCondModal
                showModal={showModal}
                setShowModal={setShowModal}
            />
        </>
    )
}
export default StripOffer;